import React from "react";
import { formatAmount } from "../utils/formatAmount";
import "../styles/modal.css";

function LedgerConfirmPopup({
  show,
  balance,
  onYes,
  onNo
}) {

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content small-modal">

        <h3>Confirm Ledger Balance</h3>

        <p>
          Do you want to confirm this balance?
        </p>

        <h2>
          JPY {formatAmount(balance)}
        </h2>

        <div className="modal-actions">

          <button
            className="modal-btn primary"
            onClick={onYes}
          >
            Yes
          </button>

          <button
            className="modal-btn secondary"
            onClick={onNo}
          >
            No
          </button>

        </div>

      </div>
    </div>
  );
}

export default LedgerConfirmPopup;